import { useCallback, useLayoutEffect, useState } from 'react'

function getOrientationType() {
  if (window.screen.orientation?.type) {
    return window.screen.orientation.type.includes('portrait')
      ? 'portrait'
      : 'landscape'
  }

  // [OTO-680] In the case where the screen.orientation API is not supported, we can use
  // the window.screen.availHeight and window.screen.availWidth to determine the orientation.
  return window.screen.availHeight > window.screen.availWidth
    ? 'portrait'
    : 'landscape'
}

/**
 * Custom React hook that returns the current screen orientation. This works on both mobile and desktop.
 * @returns 'landscape' | 'portrait'
 */
export function useScreenOrientation() {
  const [state, setState] = useState<'landscape' | 'portrait'>(() =>
    getOrientationType(),
  )

  const handleOrientationChange = useCallback(() => {
    const nextOrientation = getOrientationType()
    setState((prev) => (prev !== nextOrientation ? nextOrientation : prev))
  }, [])

  useLayoutEffect(() => {
    screen.orientation?.addEventListener('change', handleOrientationChange)

    return () => {
      screen.orientation?.removeEventListener('change', handleOrientationChange)
    }
  }, [handleOrientationChange])

  return state
}
